import { Phone } from "lucide-react";
import { telHref } from "@/lib/brief";
import { cn } from "@/lib/utils";

const NO_PHONE_TITLE = "Pas de numéro utilisable";

/** Bouton « Appeler » : lien `tel:`, désactivé sans numéro utilisable. */
export function CallButton({
  phone,
  variant = "outline",
  className,
}: {
  phone: string | null | undefined;
  variant?: "icon" | "solid" | "outline";
  className?: string;
}) {
  const href = telHref(phone);
  const icon = variant === "icon";
  const classes = cn(
    icon
      ? "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[var(--color-border-strong)] bg-[var(--color-surface)] text-[var(--color-navy-700)] transition-colors hover:bg-[var(--color-muted)] sm:h-9 sm:w-9"
      : cn("btn", variant === "solid" ? "btn-primary" : "btn-outline"),
    !href && "cursor-not-allowed opacity-50",
    className,
  );
  const content = (
    <>
      <Phone size={16} aria-hidden="true" />
      {icon ? null : "Appeler"}
    </>
  );
  if (!href) {
    return (
      <button
        type="button"
        disabled
        title={NO_PHONE_TITLE}
        aria-label={icon ? "Appeler" : undefined}
        className={classes}
      >
        {content}
      </button>
    );
  }
  return (
    <a
      href={href}
      onClick={(e) => e.stopPropagation()}
      aria-label={icon ? "Appeler" : undefined}
      className={classes}
    >
      {content}
    </a>
  );
}
